export enum LoggedInUserType {
    IDWAL_ADMIN = 0,
    DOCUMENT_COLLECTOR = 1,
    IDWAL_SURVEYOR = 2
}